import React, {useState} from "react";
import {Box, Button, ListItemIcon, ListItemText, MenuItem, MenuList, Popover} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Add01Icon} from "@hugeicons/core-free-icons";
import {NodeType, NodeTypeIcon} from "../../../../../model/ModelData";
import {UI, rgba} from "../../uiTokens";

const FORM_NODE_TYPES = [
    {type: NodeType.TEXT, label: "Text"},
    {type: NodeType.INPUT, label: "Input"},
    {type: NodeType.QA, label: "QA"},
    {type: NodeType.RECOMMENDATION, label: "Recommendation"},
    {type: NodeType.HOOK, label: "Hook"},
    {type: NodeType.START_FLOW, label: "Flow"},
    {type: NodeType.SET_VAR, label: "Set"},
];

export const CreateFormNodeButton = ({onSelect}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const close = () => setAnchorEl(null);

    return (
        <Box sx={{px: 0, py: 0.5}}>
            <Button
                fullWidth
                variant="primary"
                startIcon={<HugeiconsIcon icon={Add01Icon} size={16}/>}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(event) => setAnchorEl(event.currentTarget)}
                sx={{textTransform: "none"}}
            >
                Create new form item
            </Button>
            <Popover
                anchorEl={anchorEl}
                open={open}
                onClose={close}
                anchorOrigin={{vertical: "bottom", horizontal: "left"}}
                transformOrigin={{vertical: "top", horizontal: "left"}}
                slotProps={{
                    paper: {
                        sx: {
                            mt: 0.5,
                            width: 264,
                            px: 0.5,
                            borderRadius: "12px",
                            border: `1px solid ${rgba(UI.accent, 0.16)}`,
                            boxShadow: UI.shadow,
                        },
                    },
                }}
            >
                <MenuList dense sx={{py: 0.5}}>
                    {FORM_NODE_TYPES.map((item) => (
                        <MenuItem
                            key={item.type}
                            onClick={() => {
                                onSelect(item.type);
                                close();
                            }}
                            sx={{
                                borderRadius: "8px",
                                my: 0.15,
                                py: 0.75,
                                color: UI.muted,
                                "& .MuiListItemIcon-root": {minWidth: 30, color: UI.accent},
                                "& svg": {width: 18, height: 18},
                                "&:hover": {backgroundColor: rgba(UI.accent, 0.08), color: UI.ink},
                            }}
                        >
                            <ListItemIcon>
                                {(() => {
                                    const Icon = NodeTypeIcon[item.type];
                                    return Icon ? <Icon size={18}/> : null;
                                })()}
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{fontSize: 13, fontWeight: 500}}>
                                {item.label}
                            </ListItemText>
                        </MenuItem>
                    ))}
                </MenuList>
            </Popover>
        </Box>
    );
};
